import context from '@/context'
import { allowErrorDialog } from '@/utils/fetch'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import getComponentKey from '@/utils/getComponentKey'
import { downloadFile } from '@/utils/downloader'

export const initialState = {
  fetching: false,
  downloaderKey: getComponentKey(),
  error: null
}

export const actionTypes = {
  fetching: 'cbsReports/fetching',
  fetched: 'cbsReports/fetched',
  error: 'cbsReports/error'
}

export const actionCreators = {
  downloadCbsReport: (id) => (dispatch) => {
    const finishDownload = () => {
      dispatch({ type: actionTypes.fetched })
    }
    const onError = () => dispatch({ type: actionTypes.error, update: { fetching: false } })

    dispatch({ type: actionTypes.fetching, payload: true })
    context.api.individualService.downloadReportFromCbs(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetching, payload: false })
        if (response.isOk) {
          downloadFile(
            response.guid,
            context.api.individualService.download,
            null, // onProgress
            finishDownload, // onComplete
            onError
          )
        } else {
          dispatch(dialogActions.openDialog({
            dialogType: dialogTypes.alert,
            content: response.errorMessage
          }))
        }
      })
      .catch(onError)
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: action.payload }
    case actionTypes.fetched: return { ...state, fetching: false, downloaderKey: getComponentKey() }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/cbsReports.js